<app-tree-table
  [actionColumnWidth]="isCreateAllowed ? 430 : 360"
  [columns]="columns"
  [createLabels]="['MAPPING_CATALOGS.ADD_GROUP', 'MAPPING_CATALOGS.ADD_DETAIL']"
  [deepNestingAllowed]="true"
  [editable]="true"
  [focusLabelKey]="'MAPPING_CATALOGS.FOCUS'"
  [hierarchyLevels]="hierarchyLevels"
  [isCreateAllowed]="isCreateAllowed"
  [pagination]="false"
  [showFrozenColumnSelection]="false"
  [sortField]="'id'">
  <ng-template
    (onClick)="showColumnSelection()"
    appToolbarButton
    icon="fal fa-columns"
    labelKey="MAPPING_CATALOGS.COLUMNS"></ng-template>

  @if (!isCreateAllowed && isRodixAdmin()) {
    <ng-template
      (onClick)="resetToDefault()"
      appToolbarButton
      icon="fal fa-undo"
      labelKey="MAPPING_CATALOGS.RESET_TO_DEFAULT"></ng-template>
  }

  @if (isRodixAdmin()) {
    <ng-template
      (onClick)="downloadMappingCatalog()"
      appToolbarButton
      icon="fal fa-download"
      labelKey="MAPPING_CATALOGS.DOWNLOAD_MAPPING"></ng-template>

    <ng-template
      (onClick)="openEpicExportConfig()"
      appToolbarButton
      icon="fal fa-file-download"
      labelKey="MAPPING_CATALOGS.DOWNLOAD_EPIC"></ng-template>
  }

  <ng-template
    (onClick)="showDetailForRow($event.row)"
    [displayIf]="'node.data.detail'"
    appActionButton
    icon="fal fa-search"
    labelKey="GLOBAL.DETAILS"></ng-template>

  @if (!isCreateAllowed) {
    <ng-template
      (onClick)="setActive($event.row, false)"
      [displayIf]="'node.data.canDeactivate'"
      appActionButton
      icon="fal fa-ban"
      labelKey="ACTIONS.DEACTIVATE"></ng-template>
    <ng-template
      (onClick)="setActive($event.row, true)"
      [displayIf]="'node.data.canActivate'"
      appActionButton
      icon="fal fa-check"
      labelKey="ACTIONS.ACTIVATE"></ng-template>
  }
</app-tree-table>
